import { useState, Children } from 'react';
import styled from '@emotion/styled';

import { globalVariables } from '../../../designSystem/constants';

import SearchManager from '../SearchManager';
import RecentKeywordItem from './RecentKeywordItem';
// FIXME: searchManager mrt-storage 로 이관

const searchManager = new SearchManager();

interface Props {
  handleRef?: (idx: number, node: HTMLAnchorElement) => void;
  selectedIdx?: number;
  showEmpty?: boolean;
}

function RecentKeywords({ handleRef, selectedIdx, showEmpty = false }: Props) {
  const [recentKeywords, setRecentKeywords] = useState<Array<string>>(
    searchManager.getRecentKeywords(),
  );

  const handleRecentKeywordsClear = () => {
    searchManager.removeRecentKeywords();
    setRecentKeywords(searchManager.getRecentKeywords());
  };

  const handleRecentKeywordDelete = (keyword: string) => {
    searchManager.removeRecentKeyword(keyword);
    setRecentKeywords(searchManager.getRecentKeywords());
  };

  const isEmpty = recentKeywords.length === 0 || !Array.isArray(recentKeywords);

  if (isEmpty && !showEmpty) {
    return null;
  }

  return (
    <Container>
      <Header>
        <HeaderTitle>최근검색어</HeaderTitle>
        {!isEmpty && (
          <RecentKeywordAllClearButton type="button" onClick={handleRecentKeywordsClear}>
            전체삭제
          </RecentKeywordAllClearButton>
        )}
      </Header>
      {isEmpty ? (
        <EmptyState>최근검색어가 없습니다.</EmptyState>
      ) : (
        <KeywordContainer>
          {Children.toArray(
            recentKeywords.map((keyword, idx) => (
              <RecentKeywordItem
                keyword={keyword}
                index={idx}
                ref={(node: HTMLAnchorElement) => handleRef?.(idx, node)}
                isSelected={selectedIdx === idx}
                onDelete={handleRecentKeywordDelete}
              />
            )),
          )}
        </KeywordContainer>
      )}
    </Container>
  );
}

export default RecentKeywords;

const Container = styled.div`
  padding: 20px 0 8px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
`;

const HeaderTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${globalVariables.gray_800}; // gray-800
`;

const RecentKeywordAllClearButton = styled.button`
  /* reset button style */
  margin: 0;
  padding: 0;
  appearance: none;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;

  font-size: 13px;
  color: ${globalVariables.gray_500}; // gray-500
`;

const KeywordContainer = styled.div`
  margin-top: 8px;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0 12px;
    max-height: 80px;
    overflow: hidden;
  }
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  font-size: 14px;
  color: ${globalVariables.gray_400};

  @media (max-width: 768px) {
    height: 40px;
  }
`;
